export enum NCD_SOURCE {
  // Below comes from BE: 'MONETIZABLE_SOURCES'
  FavoritesRecommendation = 'favorites_recommendation',
  Homepage = 'homepage',
  CrossPromotionModal = 'cross_promotion_modal',
  ServicePage = 'service_page',
  RelativePricing = 'relative_pricing',
  ScheduleAsk = 'schedule_ask',
  InactiveCrossPromo = 'inactive_cross_promo',
  GenericSearch = 'generic_search',
  MyAppt = 'myappt',
  Seo = 'seo',
  ClientReferral = 'client_referral',
  SocialMedia = 'social_media',

  // Check 'get_ncd_type_for_params' method for additional types?
  Sailthru = 'sailthru',
  Facebook = 'facebook',
  Instagram = 'instagram',
}
